import type {
  MembershipLookupResponse,
  SavedFreelancerMembership,
} from "./types";

// Pure normalizer for the membership lookup response.
//
// The BE returns a map that ONLY contains saved (and visible) freelancer profile ids —
// an id that was queried but is not present in the map means "not saved" (absent, never `null`).
// This is intentionally axios-free so it can be unit-tested in the node env.
export const normalizeMembershipResponse = (
  raw: MembershipLookupResponse,
): Record<string, SavedFreelancerMembership> => {
  return raw.data ?? {};
};
